import axios from 'axios'
import urls from './urls'
import querystring from 'querystring'

/**
 * fetch order schedule for the schedule calendar
 * @param {Object} filter filter object
 *  @param {Number} [filter.transportTypeId] filter order schedule by transport type
 *  @param {Number} filter.month order schedule requested month
 *  @param {Number} filter.year order schedule requested year
 *  @param {Number} filter.transporterId transporterId
 */
const fetchOrderSchedule = async function (filter) {
  try {
    let data = {
      ...filter
    }
    let res = await axios.get(urls.orderSchedule + '?' + querystring.stringify(data))
    return res.data
  } catch (error) {
    console.log('TCL: error', error)
    return Promise.reject(error)
  }
}

export {
  fetchOrderSchedule
}
